import { render, staticRenderFns } from "./View.vue?vue&type=template&id=38551a60&scoped=true"
import script from "./View.vue?vue&type=script&lang=js"
export * from "./View.vue?vue&type=script&lang=js"
import style0 from "./View.vue?vue&type=style&index=0&id=38551a60&prod&scoped=true&lang=css"
import style1 from "./View.vue?vue&type=style&index=1&id=38551a60&prod&lang=css"
import style2 from "./View.vue?vue&type=style&index=2&id=38551a60&prod&lang=scss&scoped=true"
import style3 from "spinkit/scss/spinkit.scss?vue&type=style&index=3&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38551a60",
  null
  
)

export default component.exports